<template>
    <div >
      <MdTitle v-bind:Text="ReportTitle" />
      <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="LoadPriorAut"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="LoadPriorAut">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      <b-row>
          <b-col lg="3" md="3" sm="12">
           <!--<MdEdit 
              v-bind:Label="$t('Shared.datefrom')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'datefrom'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateFrom"
              v-bind:isRequired="false"
              v-bind:OnPressEnter="LoadPriorAut">                                     
            </MdEdit>-->
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'PriorAuthorizationFiltersRepDateFrom'"
              :Type="'date'"                  
              :isRequired="false"               
              :OnPressEnter="LoadPriorAut"                         
              :isConfirm="false"
              :ReadOnly="false">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <!--<MdEdit 
              v-bind:Label="$t('Shared.dateTo')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'dateto'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateTo"
              v-bind:isRequired="false"
              v-bind:OnPressEnter="LoadPriorAut">                                     
            </MdEdit>-->
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'PriorAuthorizationFiltersRepDateTo'"
              :Type="'date'"                  
              :isRequired="false"              
              :OnPressEnter="LoadPriorAut"                         
              :isConfirm="false"
              :ReadOnly="false">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsList"
              v-bind:Model="PatientCodeModel"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownPatients"
              :CustomLabel="customLabelPatients"/>
          </b-col>
           <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$t('Shared.Therapies')"
              v-bind:Options="TherapiesList"
              v-bind:Model="TherapiesCodeModel"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDowntherapies"
              :CustomLabel="customLabeltherapies"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$t('PriorAuthorizationFiltersRep.PriorAuthorizationStatus')"
                v-bind:Options="showOptions"
                v-bind:Model="showStatusModel"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'" 
                v-bind:Multiple="false"                      
                :Input="ChangeIsActive"
                v-bind:AllowEmpty="false"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdRadioGroup
              :Label="$t('Shared.Show')"
              :Options="showSDOptions"
              :Name="'show'"
              :value="show"
              @change="onShowChange"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12"/>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadPriorAut"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col>   
     
        </b-row>
         <div class="row">
          <div class="col-12 mt-2">
           
                <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <div class="row">
                <div class="col-md-12">
                  <MdTable  v-if="tableMode === 'SUMMARY'"
                    :key="'SUMMARY'"
                    v-bind:fields="summaryFields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
                </div>

                <div class="col-md-12">
                  <MdTable  v-if="tableMode === 'DETAIL'"
                    :key="'DETAIL'"
                    :fields="detailFields"
                    :items="items"
                    :totalRows="totalRows"
                    :showMessageIsEmpty="ShowMessageIsEmpty"
                    :currentPage="currentPage"
                    :perPage="perPage"
                    :pageOptions="pageOptions"
                    :refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    :FieldsDate="FieldsDateArr"
                  />
                </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>
            
         <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>
      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="ReportTitle"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportPrioAuttFilters"
          :ReportName="ReportName"
          :ReportTitle="ReportTitle"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    <CSVExportHelper
      ref="csvExportHelper"
      v-bind:conformSubject="ReportTitle"
      v-bind:sendEmailAPI="'/Utils/sendEmail'"
      v-bind:exportCsvAPI="'/PriorAuthorizations/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import PatientService from '@/services/patient.service'
  import ClinicalService from '@/services/clinical.service'
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import UtilsService from '@/services/utils.service'
  import Utils from "@/common/utils";

  import { EventBus } from '@/event-bus.js';

  export default Vue.extend({
      name: "PriorAuthorizationFiltersRep",
      mixins: [ ShowMessage, DBFunctions ],
      components: { DxPopup },
      data() {
          return {
              isParamVisible: true,
              isReportVisible: false,
              dateFrom: null,
              dateTo: null,
              reportParams: [],
              PatientsList:[],
              TherapiesList:[],
              TherapiesCodeModel:'',
              PatientCodeModel:'',
              showOptions: [
                { value: "", text: this.$t('Shared.All') },
                { value: "Y", text:this.$t('Shared.Active') },
                { value: "N", text: this.$t('Shared.Inactive') },
              ],
              showStatusModel: {
                "value":"true",
                "text":this.$t('Shared.Active')
              },           
              parameter:{
                SearchCriteria:null,
                PageNumber : 0,
                PageSize:0   
              },
              params: {
                PatientCodeList: "",
                TherapiesCodeList: "",
                IsActive: "Y"
              },
              showSDOptions: [
                { value: 'SUMMARY', text: this.$t('dailyServiceCharge.Summary') },
                { value: 'DETAIL', text: this.$t('dailyServiceCharge.Detail') },
              ],
              show: 'SUMMARY',
              tableMode: 'SUMMARY',
              ReportName :'PriorAuthorizationSummary',
              ReportTitle :this.$t('PriorAuthorizationFiltersRep.ReportTitleSummay'),
              items: [],         
               // ===== COLUMAS SUMMARY =====
              summaryFields: [
                { key: 'PatientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-left' },
                { key: 'PatientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-left' },
                { key: 'InsurancePolicyNo', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.InsurancePolicyNo'), class: 'text-left' },
                { key: 'PriorAuthTherapy', sortable: true, label: this.$t('MdNote.Therapy'), class: 'text-left' },
                { key: 'PriorAuthDateFrom', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.PriorAuthDateFrom'), class: 'text-center' },
                { key: 'PriorAuthDateTo', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.PriorAuthDateTo'), class: 'text-center' },
                { key: 'PriorAuthorization', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.PriorAuthorization'), class: 'text-left' },
                { key: 'UnitOrdered', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.UnitOrdered'), class: 'text-left' },
                { key: 'UnitUsed', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.UnitUsed'), class: 'text-left' },
                { key: 'UnitRemaining', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.UnitRemaining'), class: 'text-left' }
              ],

              detailExtraFields: [
                { key: 'NoteDate', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.NoteDate'), class: 'text-center' },
                { key: 'NoteName', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.NoteName'), class: 'text-left' },
                { key: 'TherapistName', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.TherapistName'), class: 'text-left' },
                { key: 'ContactDate', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.ContactDate'), class: 'text-center' },
                { key: 'Duration', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.Duration'), class: 'text-left' },
                { key: 'Activity', sortable: true, label: this.$t('PriorAuthorizationFiltersRep.Activity'), class: 'text-left' }
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:['dateFrom','dateTo'],
              dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',    
          }
      },
      computed: {
        detailFields() {
          return [...this.summaryFields, ...this.detailExtraFields]
        }
      },

      methods: {

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },

          ChangeDropDowntherapies(values){
            var therapies = '';
            if (values && values.length > 0) {
                therapies = values.map(x => x.code).join(',');
            }
            this.params.TherapiesCodeList = therapies; 
          },

          ChangeDropDownPatients(values){
            var patients = '';
            if (values && values.length > 0) {
                patients = values.map(x => x.code).join(',');
            }
            this.params.PatientCodeList = patients; 
          },

          customLabelPatients ({ description, code }) {
            return `${description} – ${code}`
          },

          customLabeltherapies  ({ name, code }) {
            return `${name} – ${code}`
          },
          
          ChangeIsActive(item) {
            this.params.IsActive = item.value
          },
         
          onShowChange(val) {
            if (!val) return
          
            this.show = val
            this.items = []
            this.currentPage = 1
            this.tableMode = null
            this.totalRows = this.items.length;

            this.$nextTick(() => {
              this.ReportName = "PriorAuthorizationSummary"
              this.ReportTitle = this.$t('PriorAuthorizationFiltersRep.ReportTitleSummay')
              this.tableMode = val
              if( val === 'DETAIL') { 
                this.ReportName = "PriorAuthorization";
                this.ReportTitle = this.$t('PriorAuthorizationFiltersRep.ReportTitle')
              }
            })
          },

          getPatients() { 
            this.PatientsList = [];
            PatientService.getPatientLookup()
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.PatientsList = response.data;
              }
            })
            .catch(error => {
              if (!error.response) {
              // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
          },

          getTherapies() {
            this.TherapiesList = []; 
            ClinicalService.getTherapies()
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.TherapiesList = response.data;
              }
            })
            .catch(error => {
              if (!error.response) {
              // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
          },


          onClickClose() {
            this.isParamVisible = false;
          },

          reportList() {
            this.checkExistFavorite('/app/reports/billing');
            this.$router.push({ name: "reportListBilling" }).catch(()=>{});
          },

          initializeParameters() {

            this.parameter.PatientCodeList = this.params.PatientCodeList && this.params.PatientCodeList !== ''
              ? this.params.PatientCodeList
              : null;
            this.parameter.TherapiesCodeList = this.params.TherapiesCodeList && this.params.TherapiesCodeList !== ''
              ? this.params.TherapiesCodeList
              : null;
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
            this.parameter.IsActive = this.params.IsActive && this.params.IsActive !== ''
              ? this.params.IsActive
              : null;
            this.parameter.Show = this.show;
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pPatientCodeList',paramValue: this.params.PatientCodeList })
            this.reportParams.push({ paramName: 'pTherapiesList',paramValue: this.params.TherapiesCodeList})
            this.reportParams.push({ paramName: 'pStatus', paramValue: this.params.IsActive})
            this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'pShow', paramValue: this.show})
          },

          onClickShowReport() {
            this.initializePdfParameters();
            this.isParamVisible = false
            this.isReportVisible = true
            this.$refs.reportPrioAuttFilters.buildDocument(this.reportParams)
          },

          LoadPriorAut() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            let procedureName = 'sp_iss_DCSpriorAuthorizationListing'; 
            if (this.show == 'SUMMARY') procedureName = 'sp_iss_DCSpriorAuthorizationListingSummary';

            this.initializeParameters();

            const spParameters = {
              SearchCriteria: this.parameter.SearchCriteria,
              DateFrom: this.parameter.DateFrom,
              DateTo: this.parameter.DateTo,
              IsActive: this.parameter.IsActive,
              PatientCodes: this.parameter.PatientCodeList,
              TherapyCodes: this.parameter.TherapiesCodeList
            };
          
            const request = {
                procedureName: procedureName,
                parameters: spParameters,
                pageNumber: this.parameter.PageNumber,
                pageSize: this.parameter.PageSize
            };

            UtilsService.getExecuteSP(request)
                .then(response => {
                    this.ShowMessageIsEmpty = false;
                    if (response.status == "200" && response.data) {
                      this.items = response.data;
                      this.items.forEach(function(element) {
                        if (element.PriorAuthDateFrom)	
                          element.PriorAuthDateFrom = Utils.formatterDateToString(element.PriorAuthDateFrom); 
                        if (element.PriorAuthDateTo)	
                          element.PriorAuthDateTo = Utils.formatterDateToString(element.PriorAuthDateTo); 
                        if (element.NoteDate)	
                          element.NoteDate = Utils.formatterDateToString(element.NoteDate);
                        if (element.ContactDate)	
                          element.ContactDate = Utils.formatterDateToString(element.ContactDate);
                      });

                      let headerString = response.headers["x-pagination"];
                      this.Header = JSON.parse(headerString);
                      this.totalRows = this.Header.TotalCount;
                    }
                    if(this.items.length === 0){
                      this.ShowMessageIsEmpty = true;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
          },
          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf(this.ReportName, true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf(this.ReportName, true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },
        },
      
      mounted () {
        this.getPatients();
        this.getTherapies();
        EventBus.$on("ShowWeel", function (isShow) { 
          isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  }
  .detail-col {
    display: none;
  } 
</style>
